export default __webpack_public_path__ + "static/media/add-employee.c578880b.svg";